export const CONTACT_PAGE_SLUG = 'contact';
